
export default {
    name: 'ReportOwnerMenu',
    props: {
        /**
         * A Report object
         */
        report: {
            type: Object,
            required: true,
        },
    },
    methods: {
        confirmDelete() {
            this.$store.dispatch('showConfirm', {
                callback: this.deleteReport,
                text: this.$t('flytipping.confirm_report_delete'),
            });
        },
        deleteReport() {
            /**
             * Delete this report
             *
             * @type {null}
             */
            this.$emit('delete-report');
        },
        markCleared() {
            /**
             * Mark this report as cleared
             *
             * @type {null}
             */
            this.$emit('mark-cleared');
        },
    },
};

